import { Box, Button, Image, Stack, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { Img } from "../../../../content/Content";
import { GoArrowUpRight } from "react-icons/go";
import "./chanel.component.css";
import { useState } from "react";
const Channel = () => {
  const ChannelBox = [
    {
      name: "FRX academy live channel to live cast ",
      logo: Img.chanelLogo1,
      pic: Img.cover1,
    },
    {
      name: "FRX academy live channel to live cast ",
      logo: Img.chanelLogo2,
      pic: Img.cover2,
    },
    {
      name: "FRX academy live channel to live cast ",
      logo: Img.chanelLogo3,
      pic: Img.cover3,
    },
    {
      name: "FRX academy live channel to live cast ",
      logo: Img.chanelLogo4,
      pic: Img.cover4,
    },
    {
      name: "FRX academy live channel to live cast ",
      logo: Img.chanelLogo6,
      pic: Img.cover6,
      active: true,
    },
    {
      name: "FRX academy live channel to live cast ",
      logo: Img.chanelLogo5,
      pic: Img.cover5,
    },
  ];
  const [showSlide, setSlide] = useState(false);
  const productChannel = showSlide
    ? ChannelBox.slice(0, 10)
    : ChannelBox.slice(0, 4);
  return (
    <VStack bgColor="rgba(245, 245, 255, 1)">
      {/* desktop-version */}
      <Box w="80%" mx="auto" className="desktop-channel">
        {/* top-bar */}
        <Stack
          flexDir="row"
          justifyContent="space-between"
          alignItems={"center"}
          w="100%"
          py="25px"
        >
          <Box>
            <Text
              color="rgba(0, 0, 0, 1)"
              fontSize="36px"
              fontWeight={"700"}
              fontFamily={"font-family: 'Poppins', sans-serif;"}
            >
              Pick a channel See all
            </Text>
          </Box>
          <Box>
            <Text
              color="rgba(0, 0, 0, 1)"
              fontSize="20px"
              fontWeight={"400"}
              cursor={"pointer"}
              fontFamily={"ProximaNova"}
            >
              See all
            </Text>
          </Box>
        </Stack>

        {/* all boxes */}
        <Stack
          flexDir="row"
          p="0"
          m="0"
          justifyContent="flex-start"
          alignItems="center"
          flexWrap="wrap"
          w={"100%"}
          gap={"0"}
        >
          {ChannelBox.map((item) => {
            return (
              <Stack w="33%" p="0" m="0" my="10px" overflow={"hidden"}>
                <Box
                  bg={
                    item.active === true
                      ? "rgba(96, 31, 235, 1)"
                      : "rgba(255, 255, 255, 1)"
                  }
                  borderRadius="20px"
                  p="30px"
                  m="10px"
                  transition="0.3s all ease-in"
                  className="channel-box"
                >
                  {/* top-bar */}
                  <Stack flexDir="row">
                    <Box
                      w="50%"
                      h={"167px"}
                      display={"flex"}
                      alignItems={"center"}
                    >
                      <img
                        src={item.logo}
                        alt="chanelLogo1"
                        height={"108px"}
                        w="194px"
                      />
                    </Box>
                    <Box
                      w="50%"
                      display={"flex"}
                      justifyContent={"flex-end"}
                      alignItems={"center"}
                    >
                      <Box
                        bg="rgba(234, 234, 234, 1)"
                        height={"100px"}
                        w="100px"
                        borderRadius="90px"
                        display={"flex"}
                        justifyContent={"center"}
                        alignItems={"center"}
                      >
                        <GoArrowUpRight style={{ fontSize: "42px" }} />
                      </Box>
                    </Box>
                  </Stack>
                  {/* title */}
                  <Stack my="4">
                    <Text
                      className="title"
                      fontSize="20px"
                      fontWeight={"500"}
                      color={"#000"}
                      lineHeight={"23.44px"}
                      py="15px"
                      fontFamily={"'Roboto', sans-serif"}
                    >
                      {item.name}
                    </Text>
                  </Stack>

                  {/* cover Image */}
                  <Stack height="233px" overflow="hidden">
                    <Image
                      src={item.pic}
                      alt="cover"
                      w="100%"
                      h="auto"
                      borderRadius={"30px"}
                    />
                  </Stack>
                </Box>
              </Stack>
            );
          })}
        </Stack>
      </Box>
      {/* mobile-version */}
      <Box w="80%" mx="auto" className="mobile-channel">
        {/* top-bar */}
        <Stack
          justifyContent="space-between"
          alignItems={"center"}
          w="100%"
          py="25px"
        >
          <Box w="100%">
            <Text
              color="rgba(0, 0, 0, 1)"
              fontSize="24px"
              fontWeight={"700"}
              fontFamily={"ProximaNova"}
              textAlign="center"
            >
              Pick a channel See all
            </Text>
          </Box>
        </Stack>

        {/* all boxes */}
        <Stack
          p="0"
          m="0"
          justifyContent="flex-start"
          alignItems="center"
          flexWrap="wrap"
          w={"100%"}
          gap={"0"}
        >
          {productChannel.map((item) => {
            return (
              <Stack w="100%" p="0" m="0" my="10px" overflow={"hidden"}>
                <Box
                  bg={
                    item.active === true
                      ? "rgba(96, 31, 235, 1)"
                      : "rgba(255, 255, 255, 1)"
                  }
                  borderRadius="20px"
                  p="30px"
                  m="10px"
                  transition="0.3s all ease-in"
                  className="channel-box"
                >
                  {/* top-bar */}
                  <Stack flexDir="row">
                    <Box
                      w="50%"
                      h={"167px"}
                      display={"flex"}
                      alignItems={"center"}
                    >
                      <img
                        src={item.logo}
                        alt="chanelLogo1"
                        height={"108px"}
                        w="194px"
                      />
                    </Box>
                    <Box
                      w="50%"
                      display={"flex"}
                      justifyContent={"flex-end"}
                      alignItems={"center"}
                    >
                      <Box
                        bg="rgba(234, 234, 234, 1)"
                        height={"100px"}
                        w="100px"
                        borderRadius="90px"
                        display={"flex"}
                        justifyContent={"center"}
                        alignItems={"center"}
                      >
                        <GoArrowUpRight style={{ fontSize: "42px" }} />
                      </Box>
                    </Box>
                  </Stack>
                  {/* title */}
                  <Stack my="4">
                    <Text
                      className="title"
                      fontSize="20px"
                      fontWeight={"500"}
                      color={"#000"}
                      lineHeight={"23.44px"}
                      py="15px"
                      fontFamily={"'Roboto', sans-serif"}
                    >
                      {item.name}
                    </Text>
                  </Stack>

                  {/* cover Image */}
                  <Stack height="233px" overflow="hidden">
                    <Image
                      src={item.pic}
                      alt="cover"
                      w="100%"
                      h="auto"
                      borderRadius={"30px"}
                    />
                  </Stack>
                </Box>
              </Stack>
            );
          })}
          <Button
            w="60%"
            mx="auto"
            bg="rgba(0, 113, 193, 1)"
            color="#fff"
            fontSize="20px"
            fontFamily="'Roboto', sans-serif"
            fontWeight="400"
            textAlign="center"
            h="49px"
            _hover={{
              color: "#ffff",
            }}
            onClick={() => setSlide(!showSlide)}
          >
            Load more
          </Button>
        </Stack>
      </Box>
    </VStack>
  );
};

export default Channel;
